import React, {useMemo, useState} from 'react';
import logo from './logo.svg';
import './styles/app.less';
import 'normalize.css/normalize.css';
import 'snack-helper/dist/snack-helper.css';
import {AuthProvider, Alert, useAuthContext} from 'geestack-toolbox';
import {BrowserRouter, Switch, Route, Link, HashRouter} from 'react-router-dom';
import CacheRoute, {CacheSwitch} from 'react-router-cache-route';
import AppPage from './pages/app';
import {onRequestFulfilled, onResponseReject} from './utils/HttpInstance';
import {Config} from './config';
import AxiosProvider from './utils/AxiosProvider';
import {message} from 'antd';

const App: React.FunctionComponent<any> = () => {
  return (
    <AuthProvider>
      <AxiosProvider
        onResponseReject={onResponseReject}
        onRequestFulfilled={onRequestFulfilled}
        axiosConfig={{
          timeout: 15 * 60 * 1000,
          baseURL: Config.basePath,
        }}
        defaultErrorHandle={error => message.error(error.message)}>
        <HashRouter>
          <AppPage />
        </HashRouter>
      </AxiosProvider>
    </AuthProvider>
  );
};

export default App;
